import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-verbatim-summarised',
  template: `<div class="container">
    <p>
      Below is an example of how an expert's answer will be displayed, based on
      the selected format.
    </p>

    <div class="output-grid">
      <div class="output-box">
        <b>Summarized</b>
        <p class="output-text">
          15-25% of patients face unmet needs due to insurance gaps, long waits,
          or high costs in accessing or affording treatment.
        </p>
      </div>

      <div class="output-box">
        <b>Verbatim</b>
        <p class="output-text">
          Yeah, so, I'd say, um, probably around 15 to maybe 25% of patients are
          still, kind of, facing unmet needs, especially when it comes to
          accessing treatment or, like, affording it. A lot of that, I think,
          comes down to things like insurance not covering certain meds, or
          people having to wait too long for appointments, or even just, like,
          out-of-pocket costs being too high ...
        </p>
      </div>
    </div>
  </div>`,
  styleUrls: ['./skeleton-verbatim-summarised.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SkeletonVerbatimSummarisedComponent {}
